import type { SVGProps } from 'react';
const DawnFlagGB = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-GB_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-GB_svg__a)">
      <path fill="#0A17A7" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m5.243 10.667-7.423 5.098 1.172 1.768 9.389-6.448v5.982h5.238v-5.982l9.388 6.448 1.172-1.769-7.423-5.097H22V5.333h-5.244L24.179.235l-1.172-1.768-9.388 6.448v-5.982H8.38v5.982l-9.389-6.448L-2.18.235l7.423 5.098H0v5.334z"
        clipRule="evenodd"
      />
      <path
        fill="#DB1F35"
        fillRule="evenodd"
        d="M24.896-1.785a.333.333 0 0 1-.092.462l-9.951 6.666a.333.333 0 0 1-.371-.554l9.951-6.666a.333.333 0 0 1 .463.092M24.92 17.269a.333.333 0 0 0-.087-.464l-8.92-6.122a.333.333 0 1 0-.378.55l8.921 6.122c.152.104.36.066.464-.086M-3.29-1.525a.333.333 0 0 1 .463-.087L6.48 4.774a.333.333 0 1 1-.378.55l-9.305-6.386a.333.333 0 0 1-.086-.463M-3.292 18.035c.103.152.31.192.463.09L7.486 11.16a.333.333 0 0 0-.373-.552l-10.315 6.964a.333.333 0 0 0-.09.463"
        clipRule="evenodd"
      />
      <path
        fill="#E6273E"
        fillRule="evenodd"
        d="M0 9.6h9.429V16h3.142V9.6H22V6.4h-9.429V0H9.43v6.4H0z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagGB;
